import React, {Component} from 'react';
import { Routes, Route, Navigate } from "react-router-dom";
import LoginPage from '../Pages/Auth/LoginPage';
import RegisterPage from '../Pages/Auth/RegisterPage';
import AuthLayout from '../components/Layout/AuthLayout';
import ResetPasswordPage from '../Pages/Auth/ResetPasswordPage';
import VerifyResetPasswordPage from '../Pages/Auth/VerifyResetPasswordPage';
import VerifyCreateUserPage from '../Pages/Auth/VerifyCreateUserPage';
import LoginAsAdminPage from '../Pages/Auth/LoginAsAdminPage';
import Verify2FaPage from '../Pages/Auth/Verify2FaPage';
import UpdateInfo from "../Pages/Auth/UpdateInfo";

class AuthRoute extends Component {
    render() {
        return (
            <AuthLayout>
                <Routes>
                    <Route path="/" element={ <Navigate replace to="/dang-nhap.html" /> } />
                    <Route exact path="/dang-nhap.html" element={<LoginPage />} />
                    <Route exact path="/tao-tai-khoan.html" element={<RegisterPage />} />
                    <Route exact path="/quen-mat-khau.html" element={<ResetPasswordPage />} />
                    <Route exact path="/kich-hoat-tai-khoan.html" element={<VerifyCreateUserPage />} />
                    <Route exact path="/xac-nhan-doi-mat-khau.html" element={<VerifyResetPasswordPage />} />
                    <Route exact path="/cap-nhat-thong-tin.html" element={<UpdateInfo />} />
                    <Route exact path="/:email/login-as-admin.html" element={<LoginAsAdminPage />} />
                    <Route exact path="/xac-thuc-2-yeu-to/xac-thuc-ma-pin.html" element={<Verify2FaPage />} />
                    <Route path="*" element={<Navigate replace to="/dang-nhap.html" />} />
                </Routes>
            </AuthLayout>
        );
    }
}
// 
export default AuthRoute;